import Bateria from '../images/foto_bateria_palheta.png';
import Guitarra from '../images/foto_guitarra_palheta.png';
import Flyer from '../images/event-image.jpeg';

export const eventsData = [
    {
        name: "Apresentação d",
        name2: "os Alunos",
        date: "28/07/2024",
        place: "Parada 7",
        hour: "15",
        value: "30.00",
        adress: "Av. Luiz Carlos Gentili de Laet, 96 - Horto Florestal",
        description: "Lorem ipsum dolor sit am minus sequi error, molestias necesus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libeis?",
        image: Bateria,
        flyer: Flyer
    },
    {
        name: "Evento",
        date: "28/07/2024",
        place: "Parada 7",
        hour: "15",
        value: "30.00",
        adress: "Av. Luiz Carlos Gentili de Laet, 96 - Horto Florestal",
        description: "Lorem ipsum dolor sit amestias necessitatibus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis?",
        image: Guitarra,
        flyer: Flyer
    },
    {
        name: "Evento",
        date: "28/07/2024",
        place: "Parada 7",
        hour: "15",
        value: "30.00",
        adress: "Av. Luiz Carlos Gentili de Laet, 96 - Horto Florestal",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciu?",
        image: Bateria,
        flyer: Flyer
    },
    {
        name: "Evento",
        date: "28/07/2024",
        place: "Parada 7",
        hour: "15",
        value: "30.00",
        adress: "Av. Luiz Carlos Gentili de Laet, 96 - Horto Florestal",
        description: "Lorem ipsum dofficia blanditiis iusto porro nesciunt aliquid libero distin non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis?",
        image: Guitarra,
        flyer: Flyer
    },
]